import { Avatar } from "antd";
import { FiBox, FiInfo, FiLayers } from "react-icons/fi";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import BackButton from "../../components/button/BackButton";
import CountButton from "../../components/button/CountButton";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import useSubCategoryDetails from "./customHooks/useSubCategoryDetails";

const SubCategoryDetails = () => {
    const { state } = useLocation();
    const history = useHistory();
    const { details, skus, loading } = useSubCategoryDetails(state);

    return (
        <div className="settings-container">
            <Container>
                <div className="d-flex justify-content-between align-items-center mb-4 px-2">
                    <div className="d-flex align-items-center gap-3">
                        <div className="bg-primary-soft p-3 rounded-circle shadow-sm">
                            <FiLayers size={24} className="text-primary" />
                        </div>
                        <div>
                            <h4 className="fw-bold text-dark mb-0">{details?.subCategoryName}</h4>
                            <p className="text-muted small mb-0">Sub-Category Specifications</p>
                        </div>
                    </div>
                    <BackButton handleClick={() => history.goBack()} />
                </div>

                <Row className="gy-4">
                    <Col lg={12}>
                        <Card className="settings-card shadow-sm border-0">
                            <CardBody className="p-4">
                                <h5 className="section-title mb-4">
                                    <FiInfo className="me-2" /> Detail Information
                                </h5>
                                <Row className="align-items-center">
                                    <Col md={3} className="text-center mb-3 mb-md-0">
                                        <div className="avatar-container shadow-sm border p-2 bg-white rounded-3 mx-auto" style={{ width: '140px', height: '140px' }}>
                                            <img
                                                src={details?.subCategoryImage ?? details?.subCategoryImageURL}
                                                alt="sub-category"
                                                className="img-fluid h-100 object-fit-contain"
                                            />
                                        </div>
                                    </Col>
                                    <Col md={9}>
                                        <Row className="gy-3">
                                            <Col sm={4}>
                                                <div className="user-badge bg-secondary-soft text-dark px-3 py-2 w-100 text-center">
                                                    <span className="text-muted me-2 small">ID:</span>
                                                    <span className="fw-bold fs-14">{details?.id}</span>
                                                </div>
                                            </Col>
                                            <Col sm={8}>
                                                <div className="user-badge bg-primary-soft text-primary px-3 py-2 w-100">
                                                    <span className="text-muted me-2 small">Parent Category:</span>
                                                    <span className="fw-bold fs-14">{details?.categoryName}</span>
                                                </div>
                                            </Col>
                                            <Col sm={12}>
                                                <div className="p-3 bg-light rounded-3 border-start border-4 border-primary mt-2">
                                                    <span className="text-muted d-block small mb-1">Status Overview</span>
                                                    <p className="mb-0 fw-500">
                                                        This sub-category currently hosts <strong className="text-primary">{skus?.length ?? 0}</strong> active product listings.
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Products Table */}
                    <Col lg={12}>
                        <Card className="settings-card shadow-sm border-0 mb-5">
                            <CardBody className="p-4">
                                <CountButton title="Products" count={skus?.length} />

                                {loading ? (
                                    <div className="mt-3">
                                        <TableSkeleton columns={6} />
                                    </div>
                                ) : skus?.length > 0 ? (
                                    <div className="modern-table-container p-0">
                                        <Table responsive className="modern-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Product</th>
                                                    <th className="text-center">SKU / ID</th>
                                                    <th className="text-center">Description</th>
                                                    <th className="text-center">Stock</th>
                                                    <th className="text-center">Manufacturer</th>
                                                    <th className="text-right">Unit Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {skus?.map((product, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                            <Avatar src={product?.imageUrl} size={40} className="shadow-sm border" />
                                                        </td>
                                                        <td className="text-center small">
                                                            <div className="fw-bold">{product?.sku}</div>
                                                            <div className="text-muted">{product?.id}</div>
                                                        </td>
                                                        <td className="fw-bold small" style={{ maxWidth: '280px', whiteSpace: 'normal' }}>
                                                            {product?.name}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`user-badge ${product.stc_quantity > 0 ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'}`}>
                                                                {product?.stc_quantity} in stock
                                                            </span>
                                                        </td>
                                                        <td className="text-center fw-500">{product?.mfg_name}</td>
                                                        <td className="text-right fw-bold text-primary">${product?.price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    <div className="text-center py-5 text-muted bg-light rounded-3 border">
                                        <FiBox size={40} className="mb-2 opacity-25" />
                                        <p className="mb-0 fw-bold">No products found in this sub-category.</p>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};


export default SubCategoryDetails;
